export default "__VITE_ASSET__d0Pl3$gS__"